module.exports = __webpack_public_path__ + "static/media/diagram-lifecycle-of-your-emotion.22dbfd97.png";